import React from "react";
import Box from "@mui/material/Box";
import logoTechMatch from "../../img/rexcornu_techmatch_logo_20230410_01.svg";
import LoginForm from "./components/LoginForm";

export default function Login() {
  return (
    <Box>
      <Box
        sx={{
          textAlign: "center",
          mt: "20px",
          mb: "60px",
          maxWidth: "300px",
          mx: "auto",
        }}
      >
        <img src={logoTechMatch} width="100%" alt="TechMatch Logo" />
      </Box>
      <LoginForm />
    </Box>
  );
}